import { useContext, createContext } from "react";
import { auth } from "config/firebase";
import { useAuthState } from 'react-firebase-hooks/auth';
import useTabFocus from 'hooks/useTabFocus';

export const FirebaseAuthContext = createContext();

export const FirebaseAuthProvider = ({ children }) => {
    const [user, authLoading] = useAuthState(auth);
    const value = { user, authLoading };

    useTabFocus();

    return (
        <FirebaseAuthContext.Provider value={value}>
            { children }
        </FirebaseAuthContext.Provider>
    )
};

export function useFirebaseAuth() {
    const context = useContext(FirebaseAuthContext)
    if (context === undefined) throw new Error("Must be used within FirebaseAuthProvider")
    return [context.user, context.authLoading];
}

